import React from 'react';
import { MdClose } from 'react-icons/md';

const DisplayAttributesModal = ({ t, showModal, data, handleCancel }) => (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '')}}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t("mastersManagement.processCost.attributesList")}</h5>
                        <button type="button" className="close border-0 p-1" aria-label="Close" onClick={handleCancel}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-body">
                       <div className="table-responsive">
                            <table className="table table-head-custom table-vertical-center table-head-bg m-0">
                                <thead>
                                    <tr className="text-left">
                                        <th className="ps-5"><span className="text-dark-75">{t("mastersManagement.manage.id")}</span></th>
                                        <th><span className="text-dark-75">{t("mastersManagement.add.name")}</span></th>
                                        <th><span className="text-dark-75">{t("mastersManagement.processCost.costAmount")}</span></th>
                                        <th><span className="text-dark-75">{t("mastersManagement.processCost.moduleType")}</span></th>
                                        <th><span className="text-dark-75">{t("mastersManagement.processCost.moduleGroup")}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map(({ id, attributeName, costAmount, moduleType, moduleGroup }) => <tr key={id}>
                                        <td className="ps-5">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{id}</span>
                                        </td>
                                        <td className="pl-0 py-8">
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{attributeName}</span>
                                        </td>
                                        <td className="pl-0 py-8">
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{costAmount}</span>
                                        </td>
                                        <td className="pl-0 py-8">
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{moduleType}</span>
                                        </td>
                                        <td className="pl-0 py-8">
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">{moduleGroup ? moduleGroup.name : '-'}</span>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                            {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("mastersManagement.noDataAvailable")}</p>}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{t("mastersManagement.add.close")}</button>
                    </div>
                </div>
            </div>
        </div>
        <div className="modal-backdrop show"></div>
    </div>
);

export default DisplayAttributesModal;